import React, { useEffect, useState } from "react";
import { Button, Flex } from "antd";

import s from "./QReportItem.less";
import ExcelDocument from "~/components/Icons/ExcelDocument";
import { IAppealSchema } from "~/entity/Appeals/model/schema";
import { dateFormat } from "~/shared/lib/DateFormat/dateFormat";
import { useAddNotificationMutation } from "~/schemas/generated/graphql";
import { STATUS_TYPES } from "~/constans/statuses";
import { NOTIFICATIONS } from "~/constans/notifications";
import ExcelIcon from "~/components/Icons/svg/excel";

interface IQReportItemProps {
  number: number;
  year: number;
  link: string;
  dealerName: string;
  inn: string;
}

export const QReportItem = (props: IQReportItemProps) => {
  const { number, year, link, dealerName, inn } = props;
  const newMonth = 3 * Number(number) + 1;
  const newYear = newMonth > 12 ? year + 1 : year;

  return (
    <Flex className={s.container} align="start" vertical>
      <p className={s.date}>
        Дата формирования: 01.{newMonth < 10 ? "0" : ""}
        {newMonth > 12 ? "01" : newMonth}.{newYear}
      </p>
      <p className={s.title}>
        Отчет за {number} квартал {dealerName} {inn}
      </p>
      <a href={link} className={s.downloadLink} download target={"_blank"}>
        <span className={s.downloadLinkContent}>
          <ExcelDocument className={s.downloadIcon} />
          <span>Скачать Excel</span>
        </span>
      </a>
    </Flex>
  );
};
